import Typography from '../../../../../../../components/Typography/Typography'

const CardOrderInfo = ({ cards }) => (
    <div className={'order-info d-flex flex-column'}>
        {cards?.map((card) => (
            <div key={card.cardid} className={'order-info--row d-flex justify-content-between'}>
                <Typography variant={'p'}>{card.name}</Typography>
                <Typography variant={'p'}>{`${card.price} ${card.currency}`}</Typography>
            </div>
        ))}
    </div>
)

export default CardOrderInfo
